
<template>
  <UIModalController>
    <template #default="{ close }">
      <template v-if="title">
        <div class="modalheader bg-darkest flex pa4 br3">
          <h1 class="f-header white">{{ title }}</h1>
          <UIButton unstyled @click="close" class="ml-auto">
            <UIIcon class="w2 db fill-white" name="x" />
          </UIButton>
        </div>
        <span class="db bar"></span>
      </template>
      <UIButton v-if="!title" unstyled @click="close" class="fr ma4">
        <UIIcon class="w2" name="x" />
      </UIButton>
      <div class="minwithcontainer pa5">
        <slot v-bind="{ close }">
          <p class="f-body" v-if="message">{{ message }}</p>
        </slot>
      </div>
    </template>
  </UIModalController>
</template>

<script>
import UIModalController from '../UIModalController.vue';
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon.vue';

export default {
  name: 'DefaultModal',
  props: {
    title: String,
    message: String,
  },
  components: {
    UIModalController,
    UIButton,
    UIIcon,
  },
};
</script>

<style lang="postcss" scoped>
.minwithcontainer {
  min-width: 50vw;
  max-width: 80vw;
}
.modalheader {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.bar {
  height: 0.7rem;
  background: var(--colorSBRed);
}
</style>
